var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5786 21.9078H28.1664C24.2346 21.9078 20.464 23.5565 17.6839 26.4911C14.9036 29.4256 13.3418 33.4058 13.3418 37.556V64.9402C13.3418 76.3531 17.637 87.2986 25.2824 95.3686C32.9277 103.439 43.2971 107.972 54.1093 107.972C64.9216 107.972 75.291 103.439 82.9363 95.3686C90.5819 87.2986 94.8772 76.3531 94.8772 64.9402V37.556C94.8772 33.4058 93.3153 29.4256 90.5348 26.4911C87.7547 23.5565 83.9841 21.9078 80.0523 21.9078H72.6401",
    stroke: "white",
    strokeOpacity: 0.17,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4023 107.972C50.4023 114.137 51.5527 120.242 53.7878 125.937C56.0227 131.632 59.2987 136.807 63.4284 141.167C67.5582 145.526 72.4609 148.984 77.8567 151.343C83.2525 153.703 89.0357 154.917 94.876 154.917C100.716 154.917 106.5 153.703 111.895 151.343C117.291 148.984 122.194 145.526 126.323 141.167C130.453 136.807 133.729 131.632 135.964 125.937C138.2 120.242 139.35 114.137 139.35 107.972V84.5",
    stroke: "white",
    strokeOpacity: 0.17,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6387 14.0833V29.7315",
    stroke: "white",
    strokeOpacity: 0.17,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5791 14.0833V29.7315",
    stroke: "white",
    strokeOpacity: 0.17,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.526 68.8515C124.526 73.0016 126.088 76.9818 128.869 79.9164C131.648 82.8509 135.419 84.4996 139.351 84.4996C143.283 84.4996 147.053 82.8509 149.834 79.9164C152.613 76.9818 154.175 73.0016 154.175 68.8515C154.175 64.7014 152.613 60.7211 149.834 57.7866C147.053 54.852 143.283 53.2034 139.351 53.2034C135.419 53.2034 131.648 54.852 128.869 57.7866C126.088 60.7211 124.526 64.7014 124.526 68.8515Z",
    stroke: "white",
    strokeOpacity: 0.17,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.f2bf204ab3ae0463f9aef05797de0596.svg";
export { ForwardRef as ReactComponent };